import React from "react";

const PixPayment: React.FC = () => {
  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <p>
        Você selecionou pagamento via PIX. Após preencher seus dados, você será
        redirecionado para a tela de pagamento.
      </p>
    </div>
  );
};

export default PixPayment;
